/**
 * Set data to local storage
 * @param key - The localStorage storage key.
 * @param value - The value to store.
 */
export const setLocalStorageItem = (key: string, value: any): void => {
  localStorage.setItem(key, JSON.stringify(value));
};

/**
 * Get data from local storage
 * @param key - The localStorage storage key.
 * @returns The parsed value from localStorage or null if not found.
 */
export const getLocalStorageItem = (key: string): any | null => {
  const item = localStorage.getItem(key);
  if (!item) return null;
  try {
    return JSON.parse(item);
  } catch {
    return item;
  }
};

/**
 * Remove data from local storage
 * @param key - The localStorage storage key to remove.
 */
export const removeLocalStorageItem = (key: string): void => {
  localStorage.removeItem(key);
};
